import React, {useCallback, useEffect, useState} from "react";
import {Accordion} from "react-bootstrap";
import {httpClient} from "../../../service";
import {ActionResult, BoardEntity, HttpMethod, PagingModel} from "../../../model";
import LoadingHtml from "../../../shared/Loading";
import ListIndex from "./ListIndex";
import {BoardSearch} from "../../../model/BoardSearch";
import ErrorPage from "../../../shared/ErrorPage";
import {useSelector} from '../../../store';


const ListHtml = (props: any) => {
    const forumCode = props.forumCode;
    const searchParam: BoardSearch = props.param;
    const categoryId: number = props.categoryId;
    const categoryNm: string = props.categoryNm;
    const isCategory = forumCode === 'help';
    const qnaType = forumCode.indexOf('qna')>=0;
    const isHelpType = forumCode === 'help' || forumCode === 'qhelp';
    const titleState = useSelector(state => state.title);
    const {searchText} = useSelector(state=>state.board);
    console.log(`listHtml load searchParam=${JSON.stringify(searchParam)}, isFrequently=${isCategory}`);
    const [items, setItems] = useState<BoardEntity[]>([]);
    const [page, setPage] = useState<number>(0);
    const [pageSize, setPageSize] = useState<number>(0);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(true);
    const [action, setAction] = useState<ActionResult>();
    const [categoryTitle, setCategoryTitle] = useState<string>(categoryNm);

    searchParam.categoryId = categoryId;
    searchParam.forumCode = forumCode;
    /*if (isCategory && categoryId === 0) {
        searchParam.frequently = true;
    } */
    //const [isFrequently,setFrequently] = useState<boolean>(false);
    //const searchParam = {page: 0, searchText: searchParam.searchText, forumCode: forumCode};


    const setData = (model: PagingModel<BoardEntity>) => {
        const paging = model.page;
        const rows = model.data;
        setPageSize(paging.pageSize);
        console.log(`setData pageSize=${pageSize}`);
        if (paging.offset > 0) {
            setItems(items.concat(rows));
        } else {
            setItems(rows);
        }

    }
    const infiniteScroll = () => {
        const scrollHeight = Math.max(document.documentElement.scrollHeight, document.body.scrollHeight);
        const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
        const clientHeight = document.documentElement.clientHeight;
        console.log('infiniteScroll start');
        if (scrollTop > 0) {
            if (scrollTop + clientHeight === scrollHeight) {
                setLoading(true);
                console.log(`scrollTop = ${scrollTop}, clientHeight=${clientHeight}, scrollHeight=${scrollHeight}`);
                getItems(true);
            }
        }
    };
    const getItems = (isScroll: boolean) => {
        let isSearch: boolean = false;
        searchParam.searchText=searchText;
        if (searchParam.searchText && searchParam.searchText !== '') {
            searchParam.frequently = undefined;
            isSearch = true;
        }
        const delay = !isScroll ? 1 : 500;
        const url = 'boards/list';
        const p = isScroll ? page + 1 : 1;
        console.log(`getItems page=${p}`);
        const param = searchParam;//: BoardSearch = {page: p, searchText: searchParam.searchText, forumCode: forumCode};
        param.page = p;
        if (page >= pageSize) {
            console.log(`getItems setPage more=false`);
            setHasMore(false);
        } else {
            if (isSearch === true) {
                setPage(0);
                console.log(`getItems setPage p=isSearch`);
            } else {
                setPage(p);
                console.log(`getItems setPage p=${p}`);
            }
        }

        const options = {
            method: HttpMethod.GET,
            url,
            body: param
        }

        setTimeout(async () => {
            const act = await httpClient(options);
            console.log(`act=${JSON.stringify(act)}`);
            setAction(act);
            if (act.result) {
                const model = act.data;
                setData(model);
                if (isSearch && categoryId === 0) {
                    setCategoryTitle(`검색결과 : ${model.page.count}`);
                } else {
                    if(!isCategory){

                        setCategoryTitle(categoryNm);
                    }
                }
            } else {
                setItems([]);
            }
            setLoading(false);

        }, delay);
        console.log(`getItems = ${JSON.stringify(param)} , hasMore=${hasMore}, count=${pageSize}`);
    };
    useEffect(() => {
        console.log(`useEffect searchParam=${JSON.stringify(searchParam)}`);
        const fetchItem = () => {
            getItems(false);
            //window.addEventListener('scroll', infiniteScroll, true);
        }

        fetchItem();

        // if(forumCode==='help'){
        //     setFrequently(true);
        // }
    }, [forumCode, searchParam, categoryId]);
    useEffect(()=>{
        if(titleState.name!=='') {
            if (isCategory) {
                console.log(`stateTitle set = ${titleState.name}`);
                setCategoryTitle(titleState.name);
                console.log(`stateTitle=${categoryTitle}`);
            }
        }
    },[titleState.name]);

    if (loading) return (<LoadingHtml/>);
    if (!action) return null;
    if (!action.result) return <ErrorPage msg={action.errorMsg} code={action.errorCode}/>
    return (
        <div className="row">
            <div className="col">
                <Accordion>
                    <h4 className="mg-md subtitle" hidden={!isHelpType}>{categoryTitle}</h4>
                    {
                        items.map((item, index) => (
                            <ListIndex item={item} index={index} key={item.id} qnaType={qnaType} helpType={isHelpType}></ListIndex>
                        ))
                    }
                </Accordion>
            </div>
        </div>
    )
}

export default ListHtml;
